import React, { useEffect, useRef } from "react";

const CUTOVER_DATE = "1 Oktober 2026";
const NEW_APP_URL = "https://erp2.mynet.co.id";

// Metronic's header/aside are `position: fixed; top: 0`, so they paint over
// anything placed before them in normal flow. Push them down by the banner's
// own height so the banner stays visible instead of being covered.
export function CutoverBanner() {
  const ref = useRef(null);

  useEffect(() => {
    const bannerEl = ref.current;
    const headerEl = document.getElementById("kt_header");
    const headerMobileEl = document.getElementById("kt_header_mobile");
    const asideEl = document.getElementById("kt_aside");
    const wrapperEl = document.getElementById("kt_wrapper");

    function applyOffset() {
      const bannerHeight = bannerEl ? bannerEl.offsetHeight : 0;
      if (headerEl) headerEl.style.top = `${bannerHeight}px`;
      if (headerMobileEl) headerMobileEl.style.top = `${bannerHeight}px`;
      if (asideEl) asideEl.style.top = `${bannerHeight}px`;
      if (wrapperEl) {
        const headerHeight = headerEl ? headerEl.offsetHeight : 0;
        wrapperEl.style.paddingTop = `${headerHeight + bannerHeight}px`;
      }
    }

    applyOffset();
    window.addEventListener("resize", applyOffset);

    return () => {
      window.removeEventListener("resize", applyOffset);
      if (headerEl) headerEl.style.top = "";
      if (headerMobileEl) headerMobileEl.style.top = "";
      if (asideEl) asideEl.style.top = "";
      if (wrapperEl) wrapperEl.style.paddingTop = "";
    };
  }, []);

  return (
    <div
      ref={ref}
      className="d-flex align-items-center justify-content-center flex-wrap px-4 py-2"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: "#ffb822",
        color: "#212121",
        fontSize: "0.95rem",
        textAlign: "center",
      }}
    >
      <span>
        <strong>Pengumuman:</strong> Aplikasi ini akan digantikan oleh sistem
        baru mulai <strong>{CUTOVER_DATE}</strong>. Mohon mulai gunakan{" "}
        <a href={NEW_APP_URL} target="_blank" rel="noopener noreferrer" style={{ color: "#212121", textDecoration: "underline" }}>
          {NEW_APP_URL}
        </a>
        .
      </span>
    </div>
  );
}
